import { render, staticRenderFns } from "./SaveToBriefingButton.vue?vue&type=template&id=9594203c&scoped=true"
import script from "./SaveToBriefingButton.vue?vue&type=script&lang=js"
export * from "./SaveToBriefingButton.vue?vue&type=script&lang=js"
import style0 from "./SaveToBriefingButton.vue?vue&type=style&index=0&id=9594203c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9594203c",
  null
  
)

export default component.exports